import {
  PIXELS_PER_MINUTE,
  buildSlots,
  positionYFor,
  timeToMinutes,
} from "@/lib/agenda-time";
import { CurrentTimeLabel } from "./CurrentTimeLabel";
import { alturaDaFaixa } from "./faixa-de-prazos";

type HoverRange = { start: string; end: string };

type Props = {
  startHour: string;
  endHour: string;
  slotDurationMinutes: number;
  /** Range destacado (slot ou range completo de um appointment). */
  highlightedRange?: HoverRange | null;
  /** Mostrar pill com horário atual. */
  showNowLabel?: boolean;
  /** Cor do pill de horário atual. */
  nowLabelColor?: string;
  /** Mesmo espaço da faixa de prazos das colunas, pra régua bater com a grade. */
  linhasDaFaixa?: number;
};

export function TimeColumn({
  startHour,
  endHour,
  slotDurationMinutes,
  highlightedRange,
  showNowLabel,
  nowLabelColor,
  linhasDaFaixa = 0,
}: Props) {
  const slots = buildSlots(startHour, endHour, slotDurationMinutes);

  return (
    <div className="sticky left-0 z-20 w-16 shrink-0 select-none border-r border-zinc-200 bg-zinc-50/60 dark:border-white/[0.05] dark:bg-background">
      <div className="sticky top-0 z-30 h-11 border-b border-zinc-200 bg-white dark:border-white/[0.06] dark:bg-card" />
      {linhasDaFaixa > 0 && (
        <div
          aria-hidden
          className="sticky top-11 z-30 border-b border-zinc-100 bg-white dark:border-white/[0.05] dark:bg-card"
          style={{ height: alturaDaFaixa(linhasDaFaixa) }}
        />
      )}

      <div className="relative">
        {slots.map((slot) => {
          const totalMinOffset = timeToMinutes(slot) - timeToMinutes(startHour);
          const top = totalMinOffset * PIXELS_PER_MINUTE;
          const height = slotDurationMinutes * PIXELS_PER_MINUTE;

          return (
            <div
              key={slot}
              className="absolute left-0 right-0 flex items-center justify-center border-t border-zinc-100 text-[11px] font-semibold tabular-nums text-zinc-700 dark:border-white/[0.04] dark:text-muted-foreground"
              style={{ top, height }}
            >
              {slot}
            </div>
          );
        })}

        {/* Overlay do range hovered — caixa pontilhada roxa SÓ NA COLUNA DE
            HORÁRIOS, agrupando os slots que o mouse está cobrindo. Um único
            elemento absoluto, CSS puro, re-renderiza só quando muda o range. */}
        {highlightedRange && (
          <div
            aria-hidden
            className="pointer-events-none absolute inset-x-0.5 rounded-md border-2 border-dashed border-brand-500/90 bg-brand-500/10 dark:border-primary/90 dark:bg-primary/10"
            style={{
              top: positionYFor(highlightedRange.start, startHour),
              height:
                (timeToMinutes(highlightedRange.end) -
                  timeToMinutes(highlightedRange.start)) *
                PIXELS_PER_MINUTE,
            }}
          />
        )}

        {showNowLabel && (
          <CurrentTimeLabel
            startHour={startHour}
            endHour={endHour}
            color={nowLabelColor}
          />
        )}

        <div
          style={{
            height:
              (timeToMinutes(endHour) - timeToMinutes(startHour)) *
              PIXELS_PER_MINUTE,
          }}
        />
      </div>
    </div>
  );
}
